<template>
    <v-container>
        <v-row>
            <v-col>
                <v-card>
                    <v-card-title class="primary">
                        <v-toolbar-title style="color: white;">
                           Enviar solicitud de factura
                        </v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-icon color="white">mdi-file-document-multiple-outline</v-icon>
                    </v-card-title>
                    <v-card-text>
                        <v-row>
                            <v-col cols="12" md="6" offset-md="3">
                                <v-card>
                                    <v-card-title>
                                        Reportes
                                    </v-card-title>
                                    <v-data-table :headers="headres2"
                                                  hide-default-footer
                                                  :items="selected">
                                    </v-data-table>
                                </v-card>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12" md="6" offset-md="3">
                                <label class="typo__label" style="color: black; text-align: center;">Fecha:</label>
                                <v-menu ref="menu1"
                                        v-model="menu1"
                                        :close-on-content-click="false"
                                        transition="scale-transition"
                                        offset-y
                                        max-width="290px"
                                        min-width="auto">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-text-field v-model="dateFormatted"
                                                      outlined
                                                      readonly
                                                      v-bind="attrs"
                                                      @blur="date = parseDate(dateFormatted)"
                                                      v-on="on"></v-text-field>
                                    </template>
                                    <v-date-picker v-model="date"
                                                   locale="es-mx"
                                                   :max="maxfecha"
                                                   :min="mindate"
                                                   @input="menu1 = false"></v-date-picker>
                                </v-menu>
                            </v-col>
                        </v-row>
                        <v-form ref="frm" v-model="valid" lazy-validation>
                            <v-row>
                                <v-col cols="12" md="6" offset-md="3">
                                    <span style="color: black; text-align: center;">Observaciones:</span>
                                    <v-textarea :counter="500"
                                                :rules="rulestextarea"
                                                outlined
                                                v-model="comentarios"
                                                required
                                                name="input-7-4"></v-textarea>
                                </v-col>
                            </v-row>
                        </v-form>
                        <v-row>
                            <v-col cols="12" class="text-center">
                                <v-btn class="ma-2"
                                       color="primary" @click="Guardar()">
                                    Guardar
                                    <template v-slot:loader>
                                        <span>Loading...</span>
                                    </template>
                                </v-btn>
                                <v-btn class="ma-2" @click="Limpiar()">
                                    Limpiar
                                </v-btn>
                                <v-btn class="ma-2" color="error" @click="Regresar()">
                                    Regresar
                                </v-btn>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
    import { mapActions, mapState } from 'vuex';
    import servicio from '@/services/TramitePago/TramitePago.Service.js';
   
    export default {
        title() {
            return this.$route.meta.title
        },
        data: vm => ({
            valid: true,
            maxfecha: new Date().toISOString(),
            date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
            dateFormatted: vm.formatDate((new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10)),
            menu1: false,
            headres2: [
                { text: 'Reporte', value: 'nrreporte', class: "text title" },
                { text: 'Asistencia', value: 'Asistencia', class: "text title" },
                { text: 'Abogado', value: 'Abogado', class: "text title" },
                { text: 'Cliente', value: 'Cliente', class: 'text title' },
                { text: 'Fecha del Reporte', value: 'svfhreporte', class: "text title" },
            ],
            rulestextarea: [
                v => !!v || 'Campo requerido',
                v => {
                    if (v == null) {
                        return true
                    }
                    else {
                        if (v.length < 12) {
                            return 'Mínimo 12 Carácteres'
                        }
                        else if (v.length > 500) {
                            return 'Máximo 500 Carácteres'
                        }
                        else
                            return true
                    }
                },
            ],
            mindate: '',
            comentarios: '',
        }),
        props: ['selected'],
        computed: {
            ...mapState([
                "domain",
                "informationPage",
                "paginacion",
                "permission",
                "user"
            ]),
            computedDateFormatted() {
                return this.formatDate(this.date)
            },
        },
        methods: {
            formatDate(date) {
                if (!date) return null

                const [year, month, day] = date.split('-')
                return `${day}/${month}/${year}`
            },
            parseDate(date) {
                if (!date) return null

                const [day, month, year] = date.split('/')
                return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
            },
            Regresar() {
                this.$router.push({ name: `SolicitarFactura` });
            },
            Limpiar() {
                this.$refs.frm.reset();
                this.date = (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10);
            },
        },
        mounted() {
            if (this.selected == null)
                this.Regresar();
        }
    }
</script>